var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pageContent"}},[_c('TopBanner',{attrs:{"bg-img":_vm.bgImg,"sub-title":_vm.mainTitle}}),_c('TabDepthMenu',{key:_vm.slidesPerView,attrs:{"tab-list":_vm.tabList,"slides-per-view":_vm.slidesPerView}}),_c('router-view',{attrs:{"className":"contents"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }